import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { signupWithLambda } from "../repository/authRepository";
import { setupAutoRefresh } from "../utils/tokenRefresh";

const Signup: React.FC = () => {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password1, setPassword1] = useState("");
  const [password2, setPassword2] = useState("");
  const [termsOfService, setTermsOfService] = useState(false);
  const [privacyPolicy, setPrivacyPolicy] = useState(false);
  const [cookiePolicy, setCookiePolicy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setIsLoading(true);

    const response = await signupWithLambda({
      username, email, password1, password2,
      terms_of_service: termsOfService,
      privacy_policy: privacyPolicy,
      cookie_policy: cookiePolicy,
    });

    if ("error" in response) {
      setError(response.error);
    } else if (response.access && response.refresh && response.user) {
      localStorage.setItem("access_token", response.access);
      localStorage.setItem("refresh_token", response.refresh);
      localStorage.setItem("user", JSON.stringify(response.user));
      setupAutoRefresh();
      navigate("/");
    } else {
      navigate("/login");
    }
    setIsLoading(false);
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h2>Sign up for Days</h2>
        {error && <div className="form-error">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-field">
            <label>Username</label>
            <input type="text" value={username} onChange={(e) => setUsername(e.target.value)} required disabled={isLoading} maxLength={30} />
          </div>
          <div className="form-field">
            <label>Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required disabled={isLoading} />
          </div>
          <div className="form-field">
            <label>Password</label>
            <input type="password" value={password1} onChange={(e) => setPassword1(e.target.value)} required disabled={isLoading} minLength={8} />
          </div>
          <div className="form-field">
            <label>Confirm Password</label>
            <input type="password" value={password2} onChange={(e) => setPassword2(e.target.value)} required disabled={isLoading} />
          </div>
          <div className="form-field">
            <label className="checkbox-label">
              <input type="checkbox" checked={termsOfService} onChange={(e) => setTermsOfService(e.target.checked)} required disabled={isLoading} />
              <span>I agree to the Terms of Service</span>
            </label>
          </div>
          <div className="form-field">
            <label className="checkbox-label">
              <input type="checkbox" checked={privacyPolicy} onChange={(e) => setPrivacyPolicy(e.target.checked)} required disabled={isLoading} />
              <span>I agree to the Privacy Policy</span>
            </label>
          </div>
          <div className="form-field">
            <label className="checkbox-label">
              <input type="checkbox" checked={cookiePolicy} onChange={(e) => setCookiePolicy(e.target.checked)} required disabled={isLoading} />
              <span>I agree to the Cookie Policy</span>
            </label>
          </div>
          <button type="submit" className="btn-primary full-width" disabled={isLoading}>
            {isLoading ? "Creating account..." : "Sign up"}
          </button>
        </form>
        <div className="auth-links">
          <a href="/login">Already have an account? Log in</a>
        </div>
      </div>
    </div>
  );
};

export default Signup;
